export default __webpack_public_path__ + "static/media/video3.d28831bc.mp4";